import { render, staticRenderFns } from "./SolicitudPivotTable.vue?vue&type=template&id=5db89c52"
import script from "./SolicitudPivotTable.vue?vue&type=script&lang=js"
export * from "./SolicitudPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports